module.exports = __webpack_public_path__ + "img/pic_button_suspend@2x.99a96206.png";